interface LoadingTableBodyWrapperProps {
  loading: boolean
  recordsCount: number
  columnsCount: number
  noDataText?: string
  children: React.ReactNode
}

function LoadingTableBodyWrapper({
  loading,
  recordsCount,
  columnsCount,
  noDataText = "No Data Found",
  children,
}: LoadingTableBodyWrapperProps) {
  return (
    <>
      {loading && recordsCount === 0 && (
        <tr>
          <td colSpan={columnsCount}>&nbsp;</td>
        </tr>
      )}
      {!loading && recordsCount === 0 && (
        <tr>
          <td colSpan={columnsCount}>{noDataText}</td>
        </tr>
      )}
      {children}
    </>
  )
}

export default LoadingTableBodyWrapper
